export default __webpack_public_path__ + "static/media/advocates_logo.f904adb0.svg";